import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_park_order = async (order) => {
    try {
        const data = {
            customer: order?.customer,
            details: order?.details,
            subtotal: order?.subtotal,
            taxamount: order?.taxamount,
            discount: order?.discount,
            delivery: order?.delivery,
            payment_status: order?.payment_status,
            payment_types: order?.payment_types,
            payments: order?.payments,
            total: order?.total,
            note: order?.note,
            title: order?.title,
            branch: order?.branch,
        };

        const token = localStorage.getItem("user");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/create-park-order`,
            data,
            config
        );

        return response?.data;
    } catch (error) {
        return error;
    }
};

const update_park_order = async (order) => {
    try {
        const data = {
            id: order?.id,
            customer: order?.customer,
            details: order?.details,
            subtotal: order?.subtotal,
            taxamount: order?.taxamount,
            discount: order?.discount,
            delivery: order?.delivery,
            payment_status: order?.payment_status,
            payment_types: order?.payment_types,
            payments: order?.payments,
            total: order?.total,
            note: order?.note,
            title: order?.title,
        };

        const token = localStorage.getItem("user");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/update-park-order`,
            data,
            config
        );

        return response?.data;
    } catch (error) {
        return error;
    }
};

const get_park_order = async (order) => {
    try {
        const data = {
            id: order?.id ? order?.id : order,
        };

        const token = localStorage.getItem("user");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/get-park-order`,
            data,
            config
        );

        return response?.data;
    } catch (error) {
        return error;
    }
};

const get_all_park_orders = async (order) => {
    try {
        const data = {
            search: order?.search,
            page: order?.page,
            status: order?.status,
        };

        const token = localStorage.getItem("user");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/get-all-park-orders`,
            data,
            config
        );

        return response?.data;
    } catch (error) {
        return error;
    }
};

const delete_park_order = async (order) => {
    try {
        const data = {
            id: order?.id,
        };

        const token = localStorage.getItem("user");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/delete-park-order`,
            data,
            config
        );

        return response?.data;
    } catch (error) {
        return error;
    }
};

export {
    create_park_order,
    update_park_order,
    get_park_order,
    get_all_park_orders,
    delete_park_order,
};